'use-client';
import classnames from 'clsx';
import * as React from 'react';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import semanticClassNames from '../../../Container.semanticClassNames';
import type {
  IContainerProps,
  IContainerImperativeActions,
} from '../../../Container.types';
import { ContainerLogic } from '../../shared/ContainerLogic';
import styles from './SloopyArea.scss';

const SloopyArea: React.ForwardRefRenderFunction<
  IContainerImperativeActions,
  IContainerProps
> = (props, ref) => {
  return (
    <ContainerLogic
      {...props}
      ref={ref}
      className={classnames(styles.root, props.className)}
      renderSlot={({ containerChildren }) => (
        <>
          <div
            className={classnames(
              styles.bg,
              formatClassNames(
                semanticClassNames.root,
                ...(props.customClassNames || []),
              ),
            )}
          />
          <div className={styles.bg2} />
          {containerChildren}
        </>
      )}
    />
  );
};

export default React.forwardRef(SloopyArea);
